package com.nonopn.skywatcher.design.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.graphics.Color

val LocalApplicationColorTheme = compositionLocalOf<ApplicationColorTheme> {
    error("No ApplicationColorTheme, check LocalApplicationColorTheme")
}

data class ApplicationColorTheme(
    val fonts: ApplicationColorThemeFont,
    val weather: ApplicationColorThemeWeather
)

data class ApplicationColorThemeWeather(
    val rainProbabilityMain: Color,
    val rainProbabilitySecondary: Color,
    val humidityProbabilityMain: Color,
    val humidityProbabilitySecondary: Color,
)

data class ApplicationColorThemeFont(
    val graySemiTransparent: Color,
    val regular: Color,
    val regularLighter: Color,
)

private val darkThemeColorEnvironment = ApplicationColorTheme(
    fonts = ApplicationColorThemeFont(
        regular = AppColor.WhiteCream,
        regularLighter = AppColor.GrayLight,
        graySemiTransparent = AppColor.GraySemiTransparentDark
    ),
    weather = ApplicationColorThemeWeather(
        rainProbabilityMain = AppColor.BlueLighter,
        rainProbabilitySecondary = AppColor.BlueLight,
        humidityProbabilityMain = AppColor.BlueLight,
        humidityProbabilitySecondary = AppColor.Blue
    )
)

private val lightThemeColorEnvironment = ApplicationColorTheme(
    fonts = ApplicationColorThemeFont(
        regular = AppColor.GrayExtraDark,
        regularLighter = AppColor.GrayDark,
        graySemiTransparent = AppColor.GraySemiTransparentLight
    ),
    weather = ApplicationColorThemeWeather(
        rainProbabilityMain = AppColor.BlueLight,
        rainProbabilitySecondary = AppColor.BlueLighter,
        humidityProbabilityMain = AppColor.Blue,
        humidityProbabilitySecondary = AppColor.BlueLight
    )
)

@Suppress("MagicNumber")
@Composable
fun ApplicationColorTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    val colors = if (darkTheme) {
        darkThemeColorEnvironment
    } else {
        lightThemeColorEnvironment
    }

    CompositionLocalProvider(
        LocalApplicationColorTheme provides colors
    ) {
        content()
    }
}
